<div class="list_item">
  <h3>{{deviationDefinition.Name.NO}}</h3>
  <p style="margin-top: 0.2em;">{{deviationDefinition.Type | deviationTypeName}}
    <span style="float: right" *ngIf="deviationDefinition.Context !== null">Kontekst: {{deviationDefinition.Context | deviationContextName}}</span>
  </p>
</div>
